var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-canvas"},[_c('canvas',{attrs:{"id":"s-canvas","width":_vm.contentWidth,"height":_vm.contentHeight},on:{"click":_vm.handleClick}}),_c('el-link',{staticStyle:{"margin-left":"10px","color":"#5fc5ff","text-decoration":"underline"},on:{"click":_vm.handleClick}},[_vm._v("换一张")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }